import {
  CLEAR_LIBRARY,
  REMOVE_LIBRARY_ITEM,
  SET_LIBRARY_LIST,
  SET_LIBRARY_LIST_CONFIG,
  SET_LIBRARY_NOTE,
  SET_MORE_LIBRARY_POSTS,
} from '../../constants';
import { IReduxAction } from '../../interfaces';
import { ILibraryListConfig } from '../reducers';
import {
  createLibraryPost,
  deleteLibraryPost,
  getLibraryNote,
  getLibraryPosts,
  updateLibraryNote,
} from '../../../services';
import { ILibraryPost } from '../../../services/interfaces';

export const createLibraryPostAction = async (userId: string, post: ILibraryPost) => {
  const results = await createLibraryPost(userId, post);
  return results.post;
};

export const clearLibrary = (dispatch: any) => dispatch({
  type: CLEAR_LIBRARY,
});

export const getLibraryPostsAction =
  async (userId: string, listConfig: ILibraryListConfig, dispatch: any) => {
    const results = await getLibraryPosts(userId, listConfig);
    dispatch(setLibraryPost(results));
  };

export const getMoreLibraryPostsActions =
  async (userId: string, listConfig: ILibraryListConfig, dispatch: any) => {
    const results = await getLibraryPosts(userId, listConfig);
    dispatch(setMoreLibraryPost(results));
  };

export const getLibraryPostNote = async (libraryId: string, dispatch: any) => {
  const note = await getLibraryNote(libraryId);
  dispatch(setLibraryNote(note));
};

export const deleteLibraryPostAction = async (id: string | null, dispatch: any) => {
  if (id) {
    await deleteLibraryPost(id);
    dispatch(removeLibraryItem(id));
  }
};

export const updateLibraryNoteAction = async (note: any) => {
  await updateLibraryNote(note.id, note);
};

export const setLibraryPost = (payload: any): IReduxAction => ({
  payload,
  type: SET_LIBRARY_LIST,
});

export const setLibraryListConfig = (payload: any): IReduxAction => ({
  payload,
  type: SET_LIBRARY_LIST_CONFIG,
});

export const setMoreLibraryPost = (payload: any): IReduxAction => ({
  payload,
  type: SET_MORE_LIBRARY_POSTS,
});

export const setLibraryNote = (payload: any): IReduxAction => ({
  payload,
  type: SET_LIBRARY_NOTE,
});

export const removeLibraryItem = (payload: any): IReduxAction => ({
  payload,
  type: REMOVE_LIBRARY_ITEM,
});
